export default __webpack_public_path__ + "static/media/Autumn_Drapes_Btn.44166bdc.jpg";